import React from 'react';
import { useNavigate } from 'react-router-dom';
import './doctor.scss';

/**
 * 医師初回セットアップ完了画面
 */
const DoctorOnboardingCompletePage = () => {
  const navigate = useNavigate();

  return (
    <div className="doctor-onboarding-complete-page">
      <div className="complete-container">
        <div className="success-icon">✅</div>
        <h1>登録が完了しました！</h1>
        
        <div className="message-box">
          <p>
            ご登録ありがとうございます。<br />
            運営による確認が完了次第、稼働可能になります。
          </p>
          <p className="sub-message">
            確認完了後、メールまたはLINEにてご連絡いたします。<br />
            通常1〜2営業日以内に対応いたします。
          </p>
        </div>

        <div className="next-steps">
          <h3>次のステップ</h3>
          <div className="step-list">
            <div className="step-item">
              <span className="step-number">1</span>
              <div className="step-content">
                <strong>運営による確認</strong>
                <p>証明書類の確認を行います</p>
              </div>
            </div>
            <div className="step-item">
              <span className="step-number">2</span>
              <div className="step-content">
                <strong>パスワード発行</strong>
                <p>PC管理画面用のパスワードをお送りします</p>
              </div>
            </div>
            <div className="step-item">
              <span className="step-number">3</span>
              <div className="step-content">
                <strong>コミュニケーション用LINE追加</strong>
                <p>運営からの連絡用LINEを追加してください</p>
              </div>
            </div>
          </div>
        </div>

        <div className="action-buttons">
          <button
            className="primary-button"
            onClick={() => navigate('/doctor/profile')}
          >
            プロフィールを確認
          </button>
        </div>
      </div>
    </div>
  );
};

export default DoctorOnboardingCompletePage;
